import cls from "classnames";
import { useEffect } from "react";
import { Step0FormData } from "../types";
// components
import { Button, Form, Input } from "antd";

export const Step0Form: React.FC<{
  data: Step0FormData;
  visible: boolean;
  onNext: (data: Step0FormData) => void;
  onCancel: () => void;
}> = ({ data, visible, onNext, onCancel }) => {
  const [form] = Form.useForm<Step0FormData>();

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(data);
  }, [form, data]);

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      className={cls(["mt:16", { hidden: !visible }])}
      onFinish={(values) => {
        onNext(values);
      }}
    >
      <Form.Item
        label="商戶帳號"
        name={["user", "username"]}
        rules={[{ required: true, message: "商戶帳號不可空白" }]}
      >
        <Input placeholder="請輸入商戶帳號" />
      </Form.Item>

      <Form.Item required className="mb:0" label="商戶密碼">
        <Form.Item
          name={["user", "password1"]}
          rules={[{ required: true, message: "商戶密碼不可空白" }]}
        >
          <Input placeholder="請輸入商戶密碼" />
        </Form.Item>

        <Form.Item
          name={["user", "password2"]}
          dependencies={[["user", "password1"]]}
          rules={[
            { required: true, message: "請再次輸入商戶密碼" },
            {
              validator(_, value: string) {
                if (
                  value.length &&
                  value !== form.getFieldValue(["user", "password1"])
                )
                  return Promise.reject("確認修改密碼不一致");
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="請再次輸入商戶密碼" />
        </Form.Item>
      </Form.Item>

      <Form.Item
        label="商戶名稱"
        name={["user", "name"]}
        rules={[{ required: true, message: "商戶名稱不可空白" }]}
      >
        <Input placeholder="請輸入商戶名稱" />
      </Form.Item>

      <Form.Item label="商戶回調" name={["base", "callback"]}>
        <Input placeholder="請輸入商戶回調" />
      </Form.Item>

      <Form.Item label="收款錢包" name={["base", "address"]}>
        <div className="flex ai:center gap:8">
          <div>USDT</div>
          <Input placeholder="請輸入 USDT 收款錢包" />
        </div>
      </Form.Item>

      <Form.Item label="仲介費率" name={["base", "agency_rate"]}>
        <div className="flex ai:center gap:8">
          <Input placeholder="請輸入仲介費率" />
          <div>%</div>
        </div>
      </Form.Item>

      <Form.Item>
        <div className="flex jc:end gap:8">
          <Button htmlType="button" onClick={onCancel}>
            取消
          </Button>
          <Button type="primary" htmlType="submit">
            下一步
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};
